import React from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';

const EditPrinter = () => {
  const connectiontype = [
    { value: 'choose', label: 'Choose' },
    { value: 'network', label: 'Network' },
  ];
  return (
    <div>
      {/* Edit Printer */}
      <div className="modal fade" id="edit-printer">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Add Printer</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Printer Name <span> *</span>
                          </label>
                          <input type="text" className="form-control" defaultValue="HP Printer" />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Connection Type <span> *</span>
                          </label>
                          <Select
                            options={connectiontype}
                            classNamePrefix="react-select"
                            placeholder="Choose an Option"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="mb-3">
                          <label className="form-label">
                            IP Address <span> *</span>
                          </label>
                          <input type="text" className="form-control" defaultValue="151.00.1.22" />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="mb-0">
                          <label className="form-label">
                            Port <span> *</span>
                          </label>
                          <input type="text" className="form-control" defaultValue={900} />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button type="button" className="btn btn-cancel me-2" data-bs-dismiss="modal">
                        Cancel
                      </button>
                      <Link to="#" className="btn btn-submit">
                        Save Changes
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Printer */}
    </div>
  );
};

export default EditPrinter;
